export default __webpack_public_path__ + "static/media/arrows-move-filled.f4f0107b.svg";